module.exports = __webpack_public_path__ + "static/img/100108.334acce4.png";